import { DayOfWeekType } from 'lib/daysOfWeek'
import { BusinessTimeType, OpenTimeType } from 'types/store'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { saveCalendarConfirmAction } from 'reducks/confirm/actions'
import { push } from 'connected-react-router'

const saveCalendarConfirm = (
  holidays: DayOfWeekType[],
  open_time: OpenTimeType,
  order_start_time: BusinessTimeType,
  last_order_time: BusinessTimeType,
  last_pickup_time: BusinessTimeType,
  relative_pickupable_time: BusinessTimeType
) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(
      saveCalendarConfirmAction(
        holidays,
        open_time,
        order_start_time,
        last_order_time,
        last_pickup_time,
        relative_pickupable_time
      )
    )
    const store = getState().store
    const query = store.is_mellow ? '?store_type=retailer' : ''
    dispatch(push('/account/settings/confirm' + query))
  }
}

export default saveCalendarConfirm
